const responsibleGamblingPage = `plus_responsiblegamblingpage(uid: "blta9f9d8c410f765a5") {
    text
    title
}`;

export default responsibleGamblingPage;
